import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { NumberRuleService, NumberGenerationRule } from '../services/number-rule.service';

export const useNumberRules = (companyId: string | undefined) => {
    return useQuery({
        queryKey: ['number-rules', companyId],
        queryFn: async () => {
            if (!companyId) return [];
            const response = await NumberRuleService.getRules(companyId);
            if (!response.success) throw new Error(response.error || 'Failed to fetch rules');
            return response.data || [];
        },
        enabled: !!companyId
    });
};

export const useSaveNumberRule = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (rule: Partial<NumberGenerationRule>) => NumberRuleService.saveRule(rule),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['number-rules', variables.company_id] });
        }
    });
};
